export const encodeState = (state: { [key: string]: any }, shouldUrlEncode: boolean = false) => {
  const b64state = btoa(JSON.stringify(state))
  return shouldUrlEncode ? encodeURIComponent(b64state) : b64state
}

export const decodeState = (b64state: string): { [key: string]: any } => {
  const json = atob(b64state)
  return JSON.parse(json)
}

export function addToState(state: string | null, keyName: string, value: any): string {
  try {
    let decoded: { [key: string]: any }
    if (!state) {
      decoded = { [keyName]: value }
    } else {
      decoded = decodeState(state)
      decoded[keyName] = value
    }
    return encodeState(decoded)
  } catch (e) {
    return state || ''
  }
}
